<div class="modal common-right-modal provider-modal show" style="display: block;" role="dialog"  [ngClass]="{'show':showSlider}"
id="provider-details" aria-hidden="true" aria-labelledby="exampleModalToggleLabel" tabindex="-1">
    <div class="modal-dialog modal-large">
        <div class="modal-content">
            <div class="modal-header">
                <div class="title-head d-flex align-items-center">
                    <button id="btnAddGroupClose" type="button" class="btn-close tool-wrap position-relative" data-bs-dismiss="modal"
                    (click)="closePopup()" aria-label="Close">
                    <div class="custom-tooltip tooltip-top" role="tooltip">
                        <div class="arrow"></div>
                        <div class="tooltip-inner"> Close </div>
                      </div></button>
                    <h2 class="modal-title" id="exampleModalToggleLabel"> Provider Details
                    </h2>
                </div>
                <div class="btn-wrap">
                    <button type="button" class="btn-text edit" *ngIf="showEdit" data-bs-toggle="modal" (click)="showEditPopup();">Edit Details</button>
                </div>
            </div>
            <div class="modal-body insurance-modal">
                <div class="inner-loader-wraper" *ngIf="isLoader">
                    <div class="inner-loader"></div>
                </div>
                <ng-container *ngIf="!isLoader">
                <div class="row-item mb-2">
                    <div class="form-heading mb-3">
                        <h3 class="before-none flex-border"><span>Regulator</span>
                            <div class="heading-border"></div>
                        </h3>
                    </div>
                    <div class="row">
                        <div class="col-4 ">
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Regulator</label></div>
                                <div class="col detail-view">
                                    <span class="pointer">-</span> {{regulatorObjt?.regulatoryAuthority |notEmpty : "NA"}}
                                </div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Facility ID/License#</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>{{detailsList?.facilityId |notEmpty : "NA"}}</div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Validity</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>{{detailsList?.regStart | date:'MM/dd/yyyy'  }} - {{detailsList?.regEnd | date:'MM/dd/yyyy' }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row-item mb-2">
                    <div class="form-heading mb-3">
                        <h3 class="before-none flex-border"><span>Provider Details</span>
                            <div class="heading-border"></div>
                        </h3>
                    </div>
                    <div class="row">
                        <div class="col-4 ">
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Provider Name</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>{{detailsList?.providerName |notEmpty : "NA"}}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Billing Currency</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>{{billingCurrencyObj?.currencyDesc |notEmpty : "NA"}}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Status</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>Active</div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Provider Code</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>{{detailsList?.providerCode |notEmpty : "NA"}}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Provider Type</label></div>
                                <div class="col detail-view"  [tooltip]="ProvTypeObj.length>25?ProvTypeObj:null"> <span class="pointer" >-</span>{{ProvTypeObj | truncate: 25 |notEmpty : "NA"}}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Service Code Type</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span><span *ngFor="let item of serviceCode">{{item}}</span></div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Validity</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>{{detailsList?.validityStart | date:'MM/dd/yyyy' }} - {{detailsList?.validityEnd | date:'MM/dd/yyyy' }}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Speciality</label></div>
                                <div class="col detail-view" [tooltip]="specialityTypeObj.length>25?specialityTypeObj:null"> <span class="pointer">-</span>{{specialityTypeObj | truncate: 25 |notEmpty : "NA"}}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Facility Type</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>{{detailsList?.facilityType ? 'Government':'Private' |notEmpty : "NA"}}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row-item mb-2">
                    <div class="form-heading mb-3">
                        <h3 class="before-none flex-border"><span>Address</span>
                            <div class="heading-border"></div>
                        </h3>
                    </div>
                    <div class="row">
                        <div class="col-4">
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Country</label></div>
                                <div class="col detail-view">
                                    <span class="pointer">-</span>{{countryObjt?.countryName |notEmpty : "NA"}}
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Area Code</label></div>
                                <div class="col detail-view">
                                    <span class="pointer">-</span> {{detailsList?.areaCode  |notEmpty : "NA"}}
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Street Name</label></div>
                                <div class="col detail-view">
                                    <span class="pointer">-</span> {{detailsList?.streetName |notEmpty : "NA"}}
                                </div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">State / Country</label></div>
                                <div class="col detail-view">
                                    <span class="pointer">-</span>{{stateObjt?.regionName  |notEmpty : "NA"}}
                                </div>
                            </div>

                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Geo Code</label></div>
                                <div class="col detail-view">
                                    <span class="pointer">-</span> {{detailsList?.geoCode  |notEmpty : "NA"}}
                                </div>
                            </div>    
                        </div>
                        <div class="col-4">
                            
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Area</label></div>
                                <div class="col detail-view">
                                    <span class="pointer">-</span>{{detailsList?.areaName  |notEmpty : "NA"}}
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Building Name</label></div>
                                <div class="col detail-view">
                                    <span class="pointer">-</span>{{detailsList?.buildingName  |notEmpty : "NA"}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row-item mb-1">
                    <div class="form-heading mb-3">
                        <h3 class="before-none flex-border"><span>Contact Details</span>
                            <div class="heading-border"></div>
                        </h3>
                    </div>
                    <ng-container *ngIf="detailsList?.contactPerson">
                       
                    <div class="row" 
                    *ngFor="let contact of detailsList?.contactPerson; last as last" >
                        <div class="col-4">
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">First Name</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>{{contact?.contactPersonFname |notEmpty : "NA"}}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Role</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>{{contact.roles[0]?.name |notEmpty : "NA"}}</div>
                            </div>
                            
                        </div>
                        <div class="col-4">
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Middle Name</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>{{contact?.contactPersonMname |notEmpty : "NA"}}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Contact No.</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>{{contact?.countryPhoneCode?.[0]?.phoneCode}} {{contact?.contactPhone |notEmpty : "NA"}}</div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Last Name</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>{{contact?.contactPersonLname |notEmpty : "NA"}}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Contact Email</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>{{contact?.contactEmail |notEmpty : "NA"}}</div>
                            </div>
                        </div>
                        <div class="row-item mb-2">
                            <div class="form-heading form-sub-head mb-3">
                                <h3 class="before-none flex-border"><span>User</span>
                                    <div class="heading-border "></div>
                                </h3>
                            </div>
                            <div class="row"  >
                                <div class="col-4 ">
                                    <div class="row mb-2">
                                        <div class="col-5"><label class="form-label">Username</label></div>
                                        <div class="col detail-view"> <span class="pointer">-</span>{{contact?.username |notEmpty : "NA"}}</div>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="row">
                                        <div class="col-5"><label class="form-label">Password</label></div>
                                        <div class="col detail-view"> <span class="pointer">-</span>{{contact?.password ? '*********' : 'Nill'}}</div>
                                    </div>
                                </div>
                                <div class="col-12" *ngIf="!last">
                                    <hr class="doted mt-1"/>
                                </div>
                               
                            </div>
                        </div>
                    </div>
                    
               </ng-container>
                </div>
               
                <div class="row-item mb-1">
                    <div class="form-heading mb-3">
                        <h3 class="before-none flex-border"><span>Client Credentials</span>
                            <div class="heading-border"></div>
                        </h3>
                    </div>
                    <div class="row">
                        <div class="col-4 ">
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Client ID</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>{{detailsList?.client_id |notEmpty : "NA"}}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Validity</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>{{detailsList?.clientValidityStart | date:'MM/dd/yyyy'}} - {{detailsList?.clientValidityEnd | date:'MM/dd/yyyy'}}</div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">Client Secret</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>{{clientSecretMasked |notEmpty : "NA"}}</div>
                                <a  class="copy-icon tool-wrap position-relative" (click)="copyMessage(detailsList?.client_secret)">
                                    <div class="custom-tooltip tooltip-top" role="tooltip">
                                        <div class="arrow"></div>
                                        <div class="tooltip-inner"> {{copyText}} </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="row mb-2">
                                <div class="col-5"><label class="form-label">URL</label></div>
                                <div class="col detail-view"> <span class="pointer">-</span>{{detailsList?.clientUrl |notEmpty : "NA"}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
            </div>
        </div>
    </div>
</div>

